import {Action} from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { KarmaActivityModel } from '@smarttask-common/src/lib/models/Karma/Activity/KarmaActivitiyModel';

export enum karmaActivityActionTypes {
  ADD_ACTIVITY = '[KarmaActivity] Create KarmaActivity',
  UPSERT_ACTIVITY = '[KarmaActivity] Upsert KarmaActivity',
  ADD_ACTIVITIES = '[KarmaActivity] Add karmaActivity',
  UPSERT_ACTIVITIES = '[KarmaActivity] Upsert karmaActivity',
  UPDATE_ACTIVITY = '[KarmaActivity] Update KarmaActivity',
  UPDATE_ACTIVITIES = '[KarmaActivity] Update karmaActivity',
  DELETE_ACTIVITY = '[KarmaActivity] Delete KarmaActivity',
  DELETE_ACTIVITIES = '[KarmaActivity] Delete karmaActivity',
  DELETE_ALL_ACTIVITIES = '[KarmaActivity] Delete All karmaActivity',
  DELETE_ALL = '[KarmaActivity] Delete All'
}

export class AddOne implements Action{
  readonly type = karmaActivityActionTypes.ADD_ACTIVITY;
  constructor(public activity: KarmaActivityModel){

  }
}

export class AddMany implements Action{
  readonly type = karmaActivityActionTypes.ADD_ACTIVITIES;
  constructor(public activities: Array<KarmaActivityModel>){

  }
}

export class UpsertOne implements Action {
  readonly type = karmaActivityActionTypes.UPSERT_ACTIVITY;

  constructor(
    public activity: KarmaActivityModel) {}
}

export class UpsertMany implements Action {
  readonly type = karmaActivityActionTypes.UPSERT_ACTIVITIES;
  constructor(public activities: Array<KarmaActivityModel> ) {}
}

export class UpdateOne implements Action{
  readonly type = karmaActivityActionTypes.UPDATE_ACTIVITY;
  constructor(public activity: Update<KarmaActivityModel>){
    
  }
}

export class UpdateMany implements Action{
  readonly type = karmaActivityActionTypes.UPDATE_ACTIVITIES;
  constructor(public activities: Array<Update<KarmaActivityModel>>){
    
  }
}

export class DeleteOne implements Action{
  readonly type = karmaActivityActionTypes.DELETE_ACTIVITY;
  constructor(
    public id
  ){}
}

export class DeleteMany implements Action{
  readonly type = karmaActivityActionTypes.DELETE_ACTIVITIES;
  constructor(
    public ids: Array<any>
  ){}
}

export class DeleteAll implements Action{
  readonly type = karmaActivityActionTypes.DELETE_ALL_ACTIVITIES;
  constructor(public ids: Array<any>){}
}

export class DeleteState implements Action{
  readonly type = karmaActivityActionTypes.DELETE_ALL;
  constructor(
  ){}
}

export type karmaActivityActions = 
  AddOne 
  | AddMany 
  | UpsertOne 
  | UpsertMany 
  | DeleteOne 
  | DeleteMany 
  | DeleteAll
  | DeleteState
  | UpdateOne
  | UpdateMany;